import React, { FC } from 'react';
import { EmbeddedVideo } from '../../../../doctrine/components/EmbeddedVideo';
import styles from './wistia_videos.module.scss';

type Props = {
  videos: Array<{
    name: string;
    subtitle: string;
    wistia_script_assets: string;
    wistia_script_medias: string;
    wistia_video_div: string;
  }>;
};

export const WistiaVideos: FC<Props> = ({ videos }) => (
  <div className={styles.container}>
    {videos.map(video => (
      <div className={styles.videoContainer} key={video.name}>
        <EmbeddedVideo
          videoClassName={styles.video}
          wistiaScriptMediasUrl={video.wistia_script_medias}
          wistiaScriptAssetsUrl={video.wistia_script_assets}
          wistiaVideoDiv={video.wistia_video_div}
        />
        <div className={styles.videoName}>{video.name}</div>
        <div className={styles.videoSubtitle}>{video.subtitle}</div>
      </div>
    ))}
  </div>
);
